export default "__VITE_ASSET__1f60c516__"